// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__RdWRe","contacts":"styles_contacts__3rTdD","contact":"styles_contact__1MXtZ","data":"styles_data__1gMPO","emptyMessage":"styles_emptyMessage__3sFST"};